import React from 'react'
import classNames from 'classnames'
import { makeStyles } from '@material-ui/core'
import { ToggleButton } from 'web/src/app/root/components/common/locations-tree/toggle-button'
import { Highlighted } from 'web/src/app/root/components/common/highlighted'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
    name: {
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    },
    row: {
        cursor: 'pointer',
        height: '100%',
        // margin: "0 12px",
        flex: 1,
        overflow: 'hidden',
        border: '2px solid transparent',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center'
    },
    locationsTreeLabelSelected: {
        fontWeight: 'bold',
        backgroundColor: theme.primary,
        color: theme.textPrimaryReverted,
        '& > div > div': {
            fontWeight: 'bold'
        }
    },
    icon: {
        marginLeft: 'auto'
    }
}))

export function DeviceTreeNode({ node, style, icon, search }) {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)
    const data = node.data
    const hasChildren = node.isInternal
    const isLocation = data?.isLocation
    const open = node.isOpen
    const isSelected = node.isSelected
    const isNetworkDevice = data?.hasOwnProperty('router_type')
    const nameSuffixText = isNetworkDevice
        ? ` (${locale.locations.network})`
        : ''
    const name = (data?.name || data?.serial_number) + `${nameSuffixText}`

    const handleToggle = event => {
        event.stopPropagation()
        node.toggle()
    }

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <div
                style={style}
                className={classNames(classes.row, {
                    [classes.locationsTreeLabelSelected]: isSelected
                })}>
                <ToggleButton
                    toggle={handleToggle}
                    isOpen={open}
                    hasChildren={hasChildren}
                    isSelected={isSelected}
                />
                <span className={classes.name}>
                    <Highlighted text={name} highlight={search} />
                </span>
                <div className={classes.icon}>
                    {icon && !isLocation ? icon : null}
                </div>
            </div>
        </div>
    )
}
